import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-day-end',
  templateUrl: './day-end.component.html',
  styleUrls: ['./day-end.component.scss']
})
export class DayEndComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
